import IRepository from "./repository";

const GETTER_GET_AVAILABLE = 'getAvailable';
const GETTER_GET_OPENED = 'getOpened';
const GETTER_GET_MENU = 'getMenu';
const GETTER_GET_SUBMENU = 'getSubMenu';

const ACTION_SET_OPENED = 'setOpened';
const ACTION_TOGGLE_OPENED = 'toggleOpened';
const ACTION_SET_MENU = 'setMenu';
const ACTION_SET_SUBMENU = 'setSubMenu';

export default class SideMenuRepository extends IRepository {
    /**
     * Is side-menu available
     * @returns {boolean}
     */
    getAvailable() {
        return this.getters(GETTER_GET_AVAILABLE);
    }

    /**
     * Is side-menu opened
     * @returns {boolean}
     */
    getOpened() {
        return this.getters(GETTER_GET_OPENED);
    }

    /**
     * Get main menu component
     * @returns {*}
     */
    getMenu() {
        return this.getters(GETTER_GET_MENU);
    }

    /**
     * Get sub-menu component
     * @returns {*}
     */
    getSubMenu() {
        return this.getters(GETTER_GET_SUBMENU);
    }

    /**
     * Set menu opened state
     * @param opened {boolean}
     * @returns {Promise<*>}
     */
    async setOpened(opened) {
        return this.dispatch(ACTION_SET_OPENED, opened);
    }

    /**
     * Toggle menu opened state
     * @returns {Promise<*>}
     */
    async toggleOpened() {
        return this.dispatch(ACTION_TOGGLE_OPENED);
    }

    /**
     * Set main menu component
     * @param menu {*}
     * @returns {Promise<*>}
     */
    async setMenu(menu) {
        return this.dispatch(ACTION_SET_MENU, menu);
    }

    /**
     * Remove main menu component
     * @returns {Promise<*>}
     */
    async removeMenu() {
        return this.dispatch(ACTION_SET_MENU, undefined);
    }

    /**
     * Set sub-menu component
     * @param subMenu {*}
     * @returns {Promise<*>}
     */
    async setSubMenu(subMenu) {
        return this.dispatch(ACTION_SET_SUBMENU, subMenu);
    }

    /**
     * Remove sub-menu component
     * @returns {Promise<*>}
     */
    async removeSubMenu() {
        return this.dispatch(ACTION_SET_SUBMENU, undefined);
    }
}